<template>
    <div>
        <template v-if="isStatic">
            <div class="form-control form-control--static" :class="className">
                {{ item.title }}
            </div>
        </template>
        <template v-else>
            <select :id="id" :name="name" class="form-control form-control--select" :class="className" :tabindex="tabindex" @change="onChangeRanking">

                <template v-if="hasPlaceholder">
                    <option value="">{{ placeholder }}</option>
                </template>
                <template v-for="ranking in rankings">
                    <option :value="ranking.value" :selected="isSelectedRanking(ranking.value)">
                        {{ ranking.title }}
                    </option>
                </template>
            </select>
        </template>
    </div>
</template>

<script>
    export default {
        props : {
            id : {
                type : String,
                default : 'form-element-ranking'
            },
            name : {
                type : String,
                name : 'ranking'
            },
            value : {
                type : String,
                default : ''
            },
            placeholder : {
                type : String,
                default : ''
            },
            className : {
                type : String,
                default : ''
            },
            tabindex : {
                type : [String, Number],
                default : ''
            },
            isStatic : {
                type : Boolean,
                default : false
            }
        },
        data() {
            return {
                item: {title : ''},
            };
        },
        computed : {
            hasPlaceholder () {
                return this.placeholder !== '';
            },

            rankings () {
                return [
                    {
                        value: '',
                        title: 'keine'
                    },
                    {
                        value: 'red',
                        title: 'Rot (Im Notfall)'
                    },
                    {
                        value: 'yellow',
                        title: 'Gelb (Akzeptabel)'
                    },
                    {
                        value: 'green',
                        title: 'Grün (Bevorzugt)'
                    },
                ];
            }
        },
        methods : {
            onSelectRanking (ranking) {
                this.$emit('input', ranking);
                this.$emit('change', ranking);
            },

            onChangeRanking (event) {
                this.onSelectRanking(event.currentTarget.value);
            },

            isSelectedRanking (ranking) {
                return this.value === ranking;
            }
        }
    }
</script>
